import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const scrollToProducts = () => {
    document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <div className="hero-text">
          <span className="hero-eyebrow">GMP Certified · ISO 9001:2015 · USDA Organic</span>
          <h1>Herbal Wellness<br />From India to the World</h1>
          <p>Premium Ayurvedic herbs and extracts — sourced, processed, and exported to global markets with uncompromising quality.</p>
          <div className="hero-cta-group">
            <button className="hero-cta-primary" onClick={scrollToProducts}>
              Explore Products
            </button>
            <button className="hero-cta-secondary" onClick={scrollToContact}>
              Request a Sample
            </button>
          </div>
        </div>
        <div className="hero-card">
          <div className="hero-card-inner">
            <div className="hero-card-icon">🌿</div>
            <h3>Bulk Export Ready</h3>
            <ul>
              <li>Raw herb · Powder · Extract</li>
              <li>Custom packaging available</li>
              <li>Full documentation support</li>
              <li>Ships to 50+ countries</li>
            </ul>
            <button className="hero-card-cta" onClick={scrollToContact}>
              Get a Quote
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
